import {useMutation} from "@tanstack/react-query";

import {shiftsService} from "../services";
import {AcknowledgeShiftRequest, AcknowledgeShiftResponse} from "../types";

export default function useAcknowledgeShift() {
  return useMutation<AcknowledgeShiftResponse, Error, AcknowledgeShiftRequest>({
    mutationFn: (data: AcknowledgeShiftRequest) => shiftsService.acknowledgeShift(data),
    retry: false,
  });
}
